import {
  DASHBOARD_BLOCK_SET_DATA,
  DASHBOARD_BLOCK_RESET_DATA,
} from 'rebook/apps/dashboard/constants';


const initialState = {
  dashboardBlocks: null,
  dashboardState: null,
};

export default function dashboardBlockList(state = initialState, action) {
  switch (action.type) {
    case DASHBOARD_BLOCK_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case DASHBOARD_BLOCK_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
